import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import api from "../lib/api";
import { Search, User, Clock } from "lucide-react";

export function ClientSearchSelect({ selected, onSelect, includeInactive = false, placeholder = "Müvekkil seçin", testid = "client-search-select" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid={testid} onClick={() => setOpen(true)}
        className="w-full flex items-center justify-between bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-left hover:bg-slate-100 transition-colors">
        {selected
          ? <span className="text-navy-900 text-sm truncate"><span className="font-mono text-slate-400 mr-1">{selected.client_no}</span>— {selected.name}</span>
          : <span className="text-slate-400 text-sm">{placeholder}</span>}
        <Search className="w-4 h-4 text-slate-400 shrink-0 ml-2" />
      </button>
      <ClientSearchModal open={open} onClose={() => setOpen(false)} includeInactive={includeInactive}
        onPick={(c) => { onSelect(c); setOpen(false); }} />
    </>
  );
}

function ClientSearchModal({ open, onClose, onPick, includeInactive }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    if (open) {
      setQ("");
      setResults([]);
      api.get("/client-recent").then(({ data }) => setRecent(data)).catch(() => {});
    }
  }, [open]);

  useEffect(() => {
    if (!open || !q) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get(`/client-search?q=${encodeURIComponent(q)}&include_inactive=${includeInactive}`)
        .then(({ data }) => setResults(data)).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [q, open, includeInactive]);

  const list = q ? results : recent;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl p-0 overflow-hidden gap-0">
        <DialogHeader className="p-4 pb-2"><DialogTitle className="font-heading text-navy-900">Müvekkil Ara</DialogTitle></DialogHeader>
        <div className="px-4 pb-3">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input autoFocus data-testid="client-search-modal-input" value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="Ad, MUV no, yetkili…" className="pl-10 h-12 rounded-xl bg-slate-50" />
          </div>
        </div>
        <div className="max-h-[55vh] overflow-y-auto px-2 pb-3">
          {!q && recent.length > 0 && (
            <p className="flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
              <Clock className="w-3.5 h-3.5" /> Son Kullanılanlar
            </p>
          )}
          {list.length === 0 && (
            <p className="text-sm text-slate-400 text-center py-10">{q ? "Sonuç bulunamadı" : "Aramaya başlayın"}</p>
          )}
          {list.map((c) => (
            <button key={c.id} data-testid={`client-option-${c.id}`} onClick={() => onPick(c)}
              className="w-full flex items-center gap-3 px-3 py-3 rounded-xl hover:bg-slate-50 text-left transition-colors">
              <span className="w-10 h-10 rounded-xl bg-navy-900 text-white flex items-center justify-center shrink-0"><User className="w-5 h-5" /></span>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-mono text-slate-400">
                  {c.client_no}{!c.is_active && <span className="ml-2 text-brand-red font-sans">(Pasif)</span>}
                </p>
                <p className="text-sm font-medium text-navy-900 truncate">{c.name}</p>
                {c.contact_person ? <p className="text-xs text-slate-400 truncate">Yetkili: {c.contact_person}</p> : null}
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
